import { Fragment, useContext } from 'react';
import { metaContext } from '../base';
import type { GeoChartColumn, GeoData } from '../types';

export const StratigraphyGeoChartBodyColumn = ({
    column,
    geoData,
    accessor,
}: {
    accessor: string;
    column: GeoChartColumn;
    geoData: GeoData;
}) => {
    const meta = useContext(metaContext)!;

    const toDraw: Array<{ name: string; y1: number; y2: number }> = [];
    // debugger;
    if (
        geoData?.stratigraphy &&
        Object.keys(geoData.stratigraphy).length > 0 &&
        Object.hasOwn(geoData.stratigraphy, accessor)
    ) {
        for (const object of geoData.stratigraphy[accessor]) {
            const y1 = meta.depths.depthToPixelsY(object.start);
            const y2 = meta.depths.depthToPixelsY(object.end);

            toDraw.push({
                name: object.name,
                y1,
                y2,
            });
        }
    }
    
    return (
        <div style={{ width: column.width, height: meta.content.height }} className="relative">
            {toDraw.map(({ y1, y2, name }, dIndex) => {
                return (
                    <Fragment key={name}>
                        <div
                            style={{
                                top: Math.min(y1, y2),
                                height: Math.abs(y2 - y1),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'absolute',
                                width: '100%',
                            }}
                            className="absolute border-b border-t bg-gray-100"
                        >
                            <div
                                className="mx-auto py-4"
                                style={{
                                    writingMode: 'vertical-lr',
                                    transform: 'rotate(180deg)',
                                }}
                            >
                                {name}
                            </div>
                        </div>
                    </Fragment>
                );
            })}
        </div>
    );
};
